import React from 'react'

const SvgDumbbellOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 8c1.974 0 4 1.56 4 4 0 2-1.573 4-4 4-1.625 0-2.63-.884-3.124-1.5H9.123a4 4 0 11.005-4.994l1.485-.001h4.245C15.52 8.658 16.722 8 18 8zm0 2c-1.267 0-1.874 1.085-1.936 1.502H7.938a2 2 0 100 .997l8.113.001h.013c.065.374.608 1.5 1.936 1.5 1.147 0 2-.922 2-2 0-1.078-.854-2-2-2z'
    />
  </svg>
)

export default SvgDumbbellOutline
